import { useTranslation } from "react-i18next";

import { useLocale } from "@/i18n/use-locale";
import { cn } from "@/lib/cn";

/**
 * Compact Español / English toggle for public marketing chrome and the home hero.
 */
export function MarketingLocaleSwitcher({
  className,
  tone = "light",
}: {
  className?: string;
  /** `onDark` for the home hero; `light` for the equipment header. */
  tone?: "light" | "onDark";
}) {
  const { t } = useTranslation("common");
  const { locale, setLocale, locales, labels, showSwitcher } = useLocale();

  if (!showSwitcher) {
    return null;
  }

  return (
    <div
      className={cn("flex items-center gap-1 text-sm", className)}
      role="group"
      aria-label={t("language")}
    >
      {locales.map((value) => {
        const active = value === locale;
        const short = value === "es-AR" ? "ES" : "EN";

        return (
          <button
            key={value}
            type="button"
            aria-pressed={active}
            aria-label={labels[value]}
            title={labels[value]}
            className={cn(
              "rounded px-2 py-1 tracking-wide transition-colors",
              active ? "font-bold" : "font-medium",
              tone === "onDark"
                ? active
                  ? "bg-white/20 text-white"
                  : "text-white/70 hover:text-white"
                : active
                  ? "bg-[var(--marketing-navy)] text-white"
                  : "text-ink-muted hover:text-ink",
            )}
            onClick={() => {
              if (!active) {
                void setLocale(value);
              }
            }}
          >
            {short}
          </button>
        );
      })}
    </div>
  );
}
